
<kendo-appbar position="top">

    <kendo-appbar-section >
      <img  alt="Logo" class="logo" src="./assets/img/brand/{{brand}}/logo.png">
      <span *ngIf="isTrainingEnv" class="env-display-name">{{'global.testEnvInfoName' | translate}}</span>
    </kendo-appbar-section>
  
    <kendo-appbar-spacer></kendo-appbar-spacer>
  
    <!-- <kendo-appbar-section>
      <a class="navigation-tabs__link"  routerLink="/claimsCenter">{{'layout.topToolbarClaimsPanel' | translate}}</a>
    </kendo-appbar-section>
    <span class="k-appbar-separator navigation-tabs__separator"></span> -->
  

    <kendo-appbar-section>
        <div fxLayout="row">
        
                <button #anchor  class="k-button k-button-clear profile-item">
                  <kendo-icon name="user"></kendo-icon>
                  <div fxLayout="column">
  
                    <span class="user-name">{{userEmployeeProfile.referenceDescription}}</span>
                    <span *ngIf="!!userEmployeeProfile" class="user-profile"> {{'global.referenceTypes.' + userEmployeeProfile.referenceType | translate}} :<strong>{{userEmployeeProfile.referenceDescription}}</strong> </span>
                  
                  </div>
                 
                </button>
        </div>
        
    
     </kendo-appbar-section>

    <span class="k-appbar-separator navigation-tabs__separator"></span>
    <kendo-appbar-section>
      <a (click)="logoutUser()" class="navigation-tabs__link"> {{'layout.topToolbarLogout' | translate}} </a>
    </kendo-appbar-section>
  
  
  
  </kendo-appbar>
  
  <router-outlet></router-outlet>
